import { render } from "./MNotification.vue?vue&type=template&id=52d9a31a"
import script from "./MNotification.vue?vue&type=script&lang=js"
export * from "./MNotification.vue?vue&type=script&lang=js"

import "./MNotification.vue?vue&type=style&index=0&id=52d9a31a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__